import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  Paper,
  MenuItem,
  FormControl,
  Select,
  TextField,
    InputLabel,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import PackageCard from './PackageCard';
import './selectPackages.css';
import './login.css';
import { Link } from 'react-router-dom';
import InputAdornment from "@mui/material/InputAdornment";

const SelectPackages = () => {
  const [selectedPackage, setSelectedPackage] = useState('basic');
  const [companyDetails, setCompanyDetails] = useState({
    companyName: '',
    industryType: '',
    currency: '',
    address: '',
    contactNumber: '',
    companySize: ''
  });


  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validation
    if (!["image/png", "image/jpeg"].includes(file.type)) {
      alert("Only PNG or JPEG allowed");
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      alert("File size must be under 10MB");
      return;
    }

    setPreview(URL.createObjectURL(file));
  };
  // Package data
  const packages = [
    {
      id: 'starter',
      title: 'Starter',
      price: 50,
      originalPrice: 100,
      discount: 50,
      users: 3,
      branches: 1,
      days: 365,
      isPopular: false
    },
    {
      id: 'basic',
      title: 'Basic',
      price: 500,
      originalPrice: 1000,
      discount: 50,
      users: 3,
      branches: 1,
      days: 365,
      isPopular: true
    },
    {
      id: 'professional',
      title: 'Professional',
      price: 2500,
      originalPrice: 5000,
      discount: 50,
      users: 3,
      branches: 1,
      days: 365,
      isPopular: false
    }
  ];

  const handlePackageSelect = (packageId) => {
    setSelectedPackage(packageId);
  };

  const handleInputChange = (field, value) => {
    setCompanyDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSignUp = () => {
    console.log('Selected Package:', selectedPackage);
    console.log('Company Details:', companyDetails);
    // Add your sign up logic here
  };

  return (
    <Box className="select-packages-container ">
      <Box className="page-content">
        {/* Header Section */}
        <Box className="header-section">
          <Typography 
            variant="h4" 
            className="main-title"
          >
            Choose your Package
          </Typography>
          <Typography 
            variant="subtitle1" 
            className="subtitle"
          >
            Compare plans and continue to company setup
          </Typography>
        </Box>

        {/* Package Cards Section */}
        <Grid container spacing={8} className="packages-grid">
          {packages.map((pkg) => (
            <Grid item size={{ xs: 10, md: 4, lg: 2.8, xl:2.6 }}>
              <PackageCard
                title={pkg.title}
                price={pkg.price}
                originalPrice={pkg.originalPrice}
                discount={pkg.discount}
                users={pkg.users}
                branches={pkg.branches}
                days={pkg.days}
                isSelected={selectedPackage === pkg.id}
                onSelect={() => handlePackageSelect(pkg.id)}
                isPopular={pkg.isPopular}
              />
            </Grid>
          ))}
        </Grid>

        <Box className="company-details-section">
          {/* Company Details Section */}
          <Typography 
            variant="h5" 
            className="section-title"
          >
            Enter your Company Details
          </Typography>
          <Typography 
            variant="body2" 
            className="section-subtitle"
          >
            Provide your company information to create your account
          </Typography>

          <Paper 
            elevation={2} 
            className="company-details-paper"
          >

            {/* Form Fields - Restructured into 3 columns */}
            <Grid container className="packages-input-field-main-grid" spacing={2}>
              {/* Column 1: Company Name, Address */}
              <Grid item size={{ xs: 12, md: 4 }}  className="packages-input-field-grid-box" >
                <Box className="packages-input-field-box">
                 
                  <FormControl fullWidth variant="outlined">
                    <TextField
                    focused 
                      className='packages-input-field'
                      id="company-name"
                      label="Company Name"
                      size="medium"
                      variant="outlined"
                      value={companyDetails.companyName}
                      onChange={(e) => handleInputChange('companyName', e.target.value)}
                    />
                  </FormControl>
                </Box>

                <Box className="packages-input-field-box">
                  
                  <FormControl fullWidth variant="outlined">
                    <TextField
                    focused 
                      className='packages-input-field'
                      id="address"
                      label="Address"
                      multiline
                      minRows={5.6}
                      size="medium"
                      variant="outlined"
                      value={companyDetails.address}
                      onChange={(e) => handleInputChange('address', e.target.value)}
                    />
                  </FormControl>
                </Box>
              </Grid>

              {/* Column 2: Industry Type, Contact Number */}
              <Grid item size={{ xs: 12, md: 4 }} spacing={4} className="packages-input-field-grid-box" >
                <Box className="packages-input-field-box">
                  <FormControl  focused fullWidth variant="outlined">
                    <InputLabel id="demo-simple-select-label">Industry Type</InputLabel>
                    <Select
                    focused
                      labelId="demo-simple-select-label"
                      label="Industry Type"
                       className='packages-input-field'
                      value={companyDetails.industryType}
                      onChange={(e) => handleInputChange('industryType', e.target.value)}
                      size="medium"
                      variant="outlined"
                    >
                      <MenuItem value="it">IT</MenuItem>
                      <MenuItem value="finance">Finance</MenuItem>
                      <MenuItem value="healthcare">Healthcare</MenuItem>
                      <MenuItem value="manufacturing">Manufacturing</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <Box className="packages-input-field-box">
                  <FormControl fullWidth variant="outlined">
                    <TextField
                    focused 
                      className='packages-input-field'
                      label="Contact Number"
                      id="contact-number"
                      size="medium"
                      variant="outlined"
                      value={companyDetails.contactNumber}
                      onChange={(e) => handleInputChange('contactNumber', e.target.value)}
                    />
                  </FormControl>
                </Box>

   <Box className="packages-input-field-box logo-upload-box">
  <label
    className={`floating-label ${
      companyDetails.companyLogo ? 'active' : ''
    }`}
  >
    Company Logo
  </label>

  <Box
    className="logo-upload-container"
    component="label"
  >
  <Box className="logo-upload-inner">
      
      {/* Hidden File Input */}
      <input
        type="file"
        accept="image/png, image/jpeg"
        onChange={handleFileChange}
        id="image-upload"
        hidden
      />

      <label htmlFor="image-upload" style={{ cursor: "pointer" }}>
        {preview ? (
          <img
            src={preview}
            alt="Preview"
            className="upload-preview"
          />
        ) : (
          <>
            <img
              src="/images/pkgs-upload.png"
              alt="Upload"
              className="upload-icon"
            />
            <Typography className="upload-text">
              Upload a file or drag and drop
            </Typography>
            <Typography className="upload-text">
              PNG, JPEG up to 10 MB
            </Typography>
          </>
        )}
      </label>

    </Box>

          <input
            type="file"
            accept="image/png, image/jpeg"
            hidden
            onChange={(e) =>
              handleInputChange('companyLogo', e.target.files[0])
            }
          />
        </Box>
      </Box>




              </Grid>
              <Grid item size={{ xs: 12, md: 4 }}  className="packages-input-field-grid-box" >

                <Box className="packages-input-field-box">

                  <FormControl  focused fullWidth variant="outlined">
                      <InputLabel id="currency-label">Currency</InputLabel>
                    <Select
                   
                      labelId="currency-label"
                      label="Currency"
                       className='packages-input-field'
                      value={companyDetails.currency}
                      onChange={(e) => handleInputChange('currency', e.target.value)}
                      size="medium"
                      variant="outlined"
                    >
                      <MenuItem value="usd">USD</MenuItem>
                      <MenuItem value="inr">INR</MenuItem>
                      <MenuItem value="eur">EUR</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <Box className="packages-input-field-box">

                  <FormControl fullWidth variant="outlined">
                    <TextField
                    focused 
                      className='packages-input-field'
                      label="Company Size"
                      id="company-size"
                      size="medium"
                      variant="outlined"
                      value={companyDetails.companySize}
                      onChange={(e) => handleInputChange('companySize', e.target.value)}
                    />
                  </FormControl>
                </Box>
                            <Box className="terms-signup">
             
 {/* Sign Up Button */}
 <Box className="signup-actions">
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleSignUp}
                    className="signup-button-cs"
                  >
                    Sign Up
                  </Button>
                </Box>
            </Box>
              </Grid>
            </Grid>

          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default SelectPackages;